import { Task } from '@uploadcare/upload-client';
import { Meta } from 'utils/types';

const task = (data: Task) => ({
  ...data,
  entryType: 'task',
});

const tasks = ({ data, meta }: { data: Task[]; meta: Meta }) => ({
  nextPage: +meta.totalPages + 1 > +meta.page && +meta.page + 1,
  previousPage: +meta.page > 1 && +meta.page - 1,
  meta: { ...meta, page: +meta.page, totalPages: meta.totalPages + 1 },
  data: data.map((s) => task(s)),
});

export default { task, tasks };
